module.exports = require("contentful");


//////////////////
// WEBPACK FOOTER
// external "contentful"
// module id = 288
// module chunks = 0